import { useQuery } from "@tanstack/react-query";

import { TOOL_REGISTRY_KEY } from "./cache-utils";
import type { ToolLabel, ToolRegistryRecord } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface GetToolRegistryResponse {
  success: boolean;
  tool_registry: ToolRegistryRecord;
  labels: ToolLabel[];
}

export const useGetToolRegistry = (workspaceId: number | null, toolId: number | null) => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useQuery({
    queryKey: [TOOL_REGISTRY_KEY, workspaceId, toolId],
    queryFn: async (): Promise<GetToolRegistryResponse> => {
      if (!workspaceId || !toolId) {
        throw new Error("Missing workspace or tool ID");
      }
      const res = await fetch(ENDPOINTS.tool_registry.get(workspaceId, toolId), {
        headers: jsonAuthHeaders(userToken),
      });
      return handleResponse(res);
    },
    enabled: !!workspaceId && !!toolId && !!userToken,
  });
};
